module.exports = __webpack_public_path__ + "static/img/11.7fb745a6.png";